import React, { useState } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { CreateManualCashSalesForm } from "./CreateManualCashSalesForm";
import { CreateManualClientPositionForm } from "./CreateManualClientPositionForm";
import { Combobox } from "@/components/ui/combobox";
import { SelectOptionItem } from "@/lib/models/ui";
import { Label } from "@/components/ui/label";

type EntryType = "cash_sale" | "client_position";

interface CreateManualEntryDialogProps {
    isOpen: boolean;
    onClose: () => void;
    onSuccess: () => void;
    entryType: EntryType;
    defaultSourceType?: string;
}

export function CreateManualEntryDialog({ entryType, isOpen, onClose, onSuccess, defaultSourceType }: CreateManualEntryDialogProps) {
    const entryTypeOptions: SelectOptionItem<EntryType>[] = [
        { value: "cash_sale", label: "Cash Sale" },
        { value: "client_position", label: "Client Position" }
    ];

    const handleSuccess = () => {
        onSuccess();
        onClose();
    };

    const getDialogTitle = () => {
        switch (entryType) {
            case "cash_sale":
                return "Create Manual Cash Sale";
            case "client_position":
                return "Create Manual Client Position";
        }
    };

    const getDialogDescription = () => {
        switch (entryType) {
            case "cash_sale":
                return "Enter the details for the new manual cash sale entry";
            case "client_position":
                return "Enter the details for the new manual client position entry";
        }
    };

    return (
        <Dialog open={isOpen} onOpenChange={(open) => {
            if (!open) {
                onClose();
            }
        }}>
            <DialogContent className="sm:max-w-[90vw] md:max-w-[80vw] lg:max-w-[70vw] max-h-[90vh] overflow-y-auto">
                <DialogHeader>
                    <DialogTitle>{getDialogTitle()}</DialogTitle>
                    <DialogDescription>{getDialogDescription()}</DialogDescription>
                </DialogHeader>

                <div className="space-y-6">
                    {entryType === "cash_sale" ? (
                        <CreateManualCashSalesForm
                            onSuccess={handleSuccess}
                            onCancel={onClose}
                            showCancelButton={true}
                        />
                    ) : (
                        <CreateManualClientPositionForm
                            onSuccess={handleSuccess}
                            onCancel={onClose}
                            showCancelButton={true}
                            defaultSourceType={defaultSourceType}
                        />
                    )}
                </div>
            </DialogContent>
        </Dialog>
    );
}
